<template lang="html">

  <section class="buttons">
    <div>
      <modal ref="campaignModal">
        <template v-slot:header>
          <h1>Start campagne</h1>
        </template>
        <template v-slot:body>
          <div>
            <div>
              <h5 class="card-5 text-center" style="margin-bottom:40px;">Selecteer je beschikbare collega's</h5>
            </div>
            <div class="d-flex justify-content-center">
              <b-table striped hover :items="colleaguesModalDb" :fields="fields" style="max-width:65%;">
                <template v-slot:cell(isActive)="row">
                  <b-form-checkbox v-model="row.isActive" @change="colleagueActiveChanged($event)">
                  </b-form-checkbox>
                </template>
              </b-table>
            </div>
            <div>
            </div>
          </div>
        </template>
        <template v-slot:footer>

          <b-col class="text-right">
            <div>
              <b-button type="submit" value="submit" class="btn btn-danger" @click="closeCampaignModal">Annuleer</b-button>
                          <b-button :disabled="totalColleaguesAvailable === 0" class="btn btn-success" @click="startCampaign()">Start campagne</b-button>
            </div>
          </b-col>
        </template>
      </modal>

      <div class="row">
        <div class="col-md-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="h2">Campagnes - {{selectedOfficeLabel}}</h4>

              <select v-if="role === 'admin'" id="officeUsers" name="officeUsers" class="custom-select" v-model="selectedOffice" @change="onChange($event)">
                <option v-for="office in offices" v-bind:key="office.officeName" v-bind:value="office.value">{{office.officeName}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div style="margin-top:25px" v-if="isLoading === true" class="circle-loader"></div>
    </div>

    <div class="row">
      <div class="col-md-4 grid-margin stretch-card" v-if="campaignsDb === null">
        <div class="card">
          <div class="card-body">
            <h4 class="h6">Geen campagnes gevonden.</h4>
            <div class="template-demo">
              <p class="card-description"></p>
            </div>
            <b-col class="text-left">
            </b-col>
            </div>
        </div>
      </div>

      <div>

      </div>

      <div class="col-md-4 grid-margin stretch-card" v-if="!isLoading" v-for="campaign in campaignsDb" v-bind:key="campaign.campaignId">
        <div class="card">
          <div class="card-body">
            <h4 class="h4">{{campaign.name}}</h4>
            <div class="template-demo">
              <p class="card-description">
              <p>
              <span class="h7">{{campaign.description}}</span>
            </p>
              <p>
              <div v-if="campaign.contacts_called === 0">
              <span class="text-danger h5">{{campaign.contacts_called}}/{{campaign.contacts_imported}} contacten opgebeld</span>
              <div class="progress"><div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="25" class="progress-bar bg-danger progress-bar-striped progress-bar-animated" style="width: 5%;"><!----></div></div>

            </div>
              <div v-else>

                  <div v-if="campaign.contacts_called === campaign.contacts_imported">
                    <span class="text-success h5">{{campaign.contacts_called}}/{{campaign.contacts_imported}} contacten opgebeld</span>
                    <div v-if="campaign.contacts_called > 0" class="progress"><div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="25" class="progress-bar bg-success progress-bar-striped progress-bar-animated" v-bind:style="{width: getWidthProgressBar(campaign.percent_complete)}"><!----></div></div>

                  </div>
                <div v-else>
                  <span class="text-warning h5">{{campaign.contacts_called}}/{{campaign.contacts_imported}} contacten opgebeld</span>
                  <div v-if="campaign.contacts_called > 0" class="progress"><div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="25" class="progress-bar bg-warning progress-bar-striped progress-bar-animated" v-bind:style="{width: getWidthProgressBar(campaign.percent_complete)}"><!----></div></div>

                </div>
              </div>
<!--              </p>-->
<!--              <div class="progress"><div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="25" class="progress-bar bg-danger progress-bar-striped progress-bar-animated" >&lt;!&ndash;&ndash;&gt;</div></div>-->

            </div>
            <b-col class="text-left">
            </b-col>
            </div>
          <div style="position:relative; padding-bottom: 16px">
            <b-col class="text-right">
<!--              <b-button variant="primary" class="social-btn btn-rounded" style="margin-right:25px" @click="openColleagueActiveModal(campaign.campaign_id)">-->
<!--                <i class="mdi mdi-play"></i>-->
<!--              </b-button>-->
              <b-button-group>
<!--                <b-button variant="primary" class="icon-btn" @click="navigateToStatus(campaign.campaign_id)">-->
<!--                  <i class="mdi mdi-eye"></i>-->
<!--                </b-button>-->
                <b-button-group>
                  <b-button variant="warning" class="icon-btn" @click="navigateToDetails(campaign.campaign_id)">
                    <i class="mdi mdi-lead-pencil"></i>
                  </b-button>
                  <b-button variant="danger" class="icon-btn" @click="deleteCampaign(campaign)">
                    <i v-if="campaign.isDeletionClicked === undefined" class="mdi mdi-delete"></i>
                    <i v-if="campaign.isDeletionClicked !== undefined" class="mdi mdi-check"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-col>
          </div>
        </div>
      </div>
<!--      <div style="margin-top:125px" v-if="campaignsDb === null" class="circle-loader"></div>-->

      <div v-if="!isLoading"  class="col-md-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body d-flex justify-content-center">
            <div>

              <div style="height: 150px; width: 100%">
                <div>
                  <b-button style="background-color: white; border: none; margin-left: 25px" @click="newCampaign()">
                    <img style="height:75px" class="ml-0" src="../../assets/icons/np_plus_1052479_000000.svg">
                  </b-button>
                </div>
                <div>
                  <p v-if="campaignsDb.length > 0" style="text-align: center">Nieuwe campagne aanmaken</p>
                  <p v-else style="text-align: center">Maak je eerste campagne aan</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import axios from 'axios'
import Modal from '../modals/Modal'
import store from '../../store'
let server = require('../../server')

export default {
  name: 'buttons',
  components: {
    Modal
  },
  computed: {
    role () {
      return store.state.role
    },
    user () {
      return store.state.user
    },
    office () {
      return store.state.office
    },
    officeString () {
      return store.state.officeString
    }
  },
  async created () {
    let self = this
    try {
      await axios({
        method: 'get',
        url: server.SERVER_URL + '/get_campaigns_by_office_id/' + this.office
      })
        .then(function (response) {
          self.campaignsDb = response.data
          self.selectedOfficeLabel = self.officeString
          self.isLoading = false
          self.$forceUpdate()
        })
    } catch (e) {
      console.log('Error while trying to get users!')
      console.log(e)
    }
  },
  data () {
    return {
      showModal: false,
      campaignsDb: [],
      isLoading: true,
      fields: [
        {
          key: 'Voornaam',
          label: 'Naam collega'
        },
        {
          key: 'isActive',
          label: 'Is aanwezig?',
          thStyle: {width: '100px'}
        }
      ],
      totalColleaguesAvailable: 0,
      selectedCampaignId: '',
      colleaguesModalDb: [],
      selectedOffice: null,
      selectedOfficeLabel: '',
      offices: [
        {
          officeName: 'Sint-Truiden',
          value: 1
        },
        {
          officeName: 'Sint-Niklaas',
          value: 2
        },
        {
          officeName: 'Rumst',
          value: 3
        },
        {
          officeName: 'Pelt',
          value: 4
        },
        {
          officeName: 'Paal',
          value: 5
        },
        {
          officeName: 'Leuven',
          value: 6
        },
        {
          officeName: 'Herentals',
          value: 7
        },
        {
          officeName: 'Hasselt',
          value: 8
        },
        {
          officeName: 'Zaventem',
          value: 9
        },
        {
          officeName: 'Gent',
          value: 10
        },
        {
          officeName: 'Lublin',
          value: 11
        },
        {
          officeName: 'Testing',
          value: 999
        }
      ]
    }
  },
  methods: {
    async deleteCampaign (campaign) {
      console.log('Deleting campaign with id: ');
      console.log(campaign.campaign_id)
      if (campaign.isDeletionClicked) {
        try {
          await axios({
            method: 'post',
            url: server.SERVER_URL + '/archive_campaign/' + campaign.campaign_id
          })
            .then(function (response) {
              self.colleaguesModalDb = response.data
              console.log('colleaguesModalDb = ')
              console.log(self.colleaguesModalDb)
            })
        } catch (e) {
          console.log('Error while trying to get users!')
          console.log(e)
        }
        let index = this.campaignsDb.indexOf(campaign)
        this.campaignsDb.splice(index, 1)
      }
      campaign.isDeletionClicked = true
      this.$forceUpdate()
    },
    async onChange (event) {
      let officeId = event.target.value
      this.selectedOffice = event.target.value
      console.log(event.target.text)
      this.isLoading = true
      await this.getOfficeByOfficeId(this.selectedOffice)
      await this.getCampaignsByOffice(officeId)

      // todo: fetch campaigns for specific office
    },
    async startCampaign () {
      console.log('Activating campaign with id: ' + this.selectedCampaignId)
      this.totalColleaguesAvailable = 0
      this.$refs.campaignModal.closeModal()
    },
    getWidthProgressBar (percentComplete) {
      return percentComplete
    },
    async closeCampaignModal () {
      this.totalColleaguesAvailable = 0
      this.$refs.campaignModal.closeModal()
    },
    async openColleagueActiveModal (campaignId) {
      console.log('campaignId selected: ' + campaignId.toString())
      this.selectedCampaignId = campaignId
      let self = this
      this.$refs.campaignModal.openModal()
      try {
        await axios({
          method: 'post',
          url: server.SERVER_URL + '/get_users_by_office/' + this.office
        })
          .then(function (response) {
            self.colleaguesModalDb = response.data
            console.log('colleaguesModalDb = ')
            console.log(self.colleaguesModalDb)
          })
      } catch (e) {
        console.log('Error while trying to get users!')
        console.log(e)
      }
    },
    async getCampaignsByOffice (officeId) {
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/get_campaigns_by_office_id/' + officeId
        })
          .then(function (response) {
            self.campaignsDb = response.data
            self.isLoading = false
            self.$forceUpdate()
            console.log('get_campaigns_by_office (campaignsDb = ')
            console.log(response.data)
          })
      } catch (e) {
        console.log('Error while trying to get users!')
        console.log(e)
      }
    },
    async getOfficeByOfficeId (officeId) {
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/get_office_by_office_id/' + officeId.toString()
        })
          .then(function (response) {
            self.selectedOfficeLabel = response.data.location
            self.$forceUpdate()
          })
      } catch (e) {
        console.log('Error while trying to get users!')
        console.log(e)
      }
    },
    newCampaign () {
      // todo: create new campaign in back-end here
      this.$router.push({ name: 'campaignDetail', params: {campaignId: false} })
    },
    navigateToDetails (campaignId) {
      this.$router.push({ name: 'campaignDetail', params: {campaignId: campaignId} })
    },
    navigateToStatus (campaignId) {
      this.$router.push({ name: 'campaignStatus', params: {campaignId: campaignId} })
    },
    colleagueActiveChanged (e) {
      if (e === true) {
        this.totalColleaguesAvailable += 1
        this.isStep2Visible = true
        this.startCallButtonVisible = true
      } else {
        this.totalColleaguesAvailable -= 1
        this.startCallButtonVisible = false
      }

      this.validCampaign = this.totalColleaguesAvailable > 0

      console.log("Total colleagues selected: '" + this.totalColleaguesAvailable.toString() + "'")
    }
  }
}
</script>

<style scoped lang="scss">
.buttons {

}
</style>



// WEBPACK FOOTER //
// src/views/basic-elements/campaigns.vue